/**
 * Multi-select pill chips. value=string[], onChange(string[]).
 */
export default function MultiSelect({ options, value = [], onChange, testId = "multiselect" }) {
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {options.map((opt) => {
        const active = value.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => toggle(opt)}
            className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition-all ${
              active
                ? "border-wine-500 bg-wine-500 text-white"
                : "border-neutral-200 bg-white text-neutral-700 hover:border-wine-300 hover:bg-wine-50"
            }`}
            data-testid={`${testId}-${opt.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
